export default __webpack_public_path__ + "static/media/HelpCall.3256791e.svg";